import { ethers } from "ethers";
import { chainRPC, contractAddress } from "../config";
import ContractAbi from '../Assets/Abi/auction.json'


export  const  MySigner= window.ethereum ?  new ethers.providers.Web3Provider(window.ethereum).getSigner() : null
export const globalWeb3 = new ethers.providers.JsonRpcProvider(chainRPC)


export const getSigner = () => {
    const signer = globalWeb3
    return signer;
}

export const getContract = (signer = null) => {

    const signerOrProvider = signer ?? getSigner()
    console.log(signerOrProvider);
    return new ethers.Contract(contractAddress, ContractAbi, signerOrProvider)
}




// import {ethers} from "ethers";
// import Web3 from "web3";
// import { chainRPC } from "../config";

// const globalWeb3 = new ethers.providers.Web3Provider((new Web3(chainRPC)).currentProvider)

// export const getSigner = () => {
//     const signer = globalWeb3;
//     return signer;
// }

// export const getContract = ( address, abi, signer = null ) => {
//     const signerOrProvider = signer ?? getSigner()
//     return new ethers.Contract( address, abi, signerOrProvider )
// }
